import { onMounted as i, onBeforeUnmount as d } from "vue";
import { isBrowser as r } from "./ghl-ui.es708.js";
let n, t;
const f = () => {
  var o, e;
  n = r ? (e = (o = document) === null || o === void 0 ? void 0 : o.fonts) === null || e === void 0 ? void 0 : e.ready : void 0, t = !1, n !== void 0 ? n.then(() => {
    t = !0;
  }) : t = !0;
};
f();
function a(o) {
  if (t)
    return;
  let e = !1;
  i(() => {
    t || n == null || n.then(() => {
      e || o();
    });
  }), d(() => {
    e = !0;
  });
}
export {
  a as default,
  f as init
};
